module.exports = __webpack_public_path__ + "img/vip_sign_1.3bf9cba9.png";